import React, { useState } from 'react';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core';
import ChecklistDetails from './ChecklistDetails';
import withAppStylesGrid from 'HOCs/withAppStyles';
import { getChecklistSettings, ProjectConfiguration } from 'utils/ProjectConfigurationUtil';


export default function ChecklistGrid({ customFilter,callback }) {
  const columns = ProjectConfiguration.columnsChecklistFields
  const theme = useTheme();

  const { selectedProject } = useAppContext();
  const [updateDate,setUpdateDate] = useState(new Date());
  const [page, setPage] = useState(0);
  const title = "Checklist Settings";

  const DataGrid = withAppStylesGrid(MaterialTable, { defaultFilters: { projectId: selectedProject, ...customFilter }, theme, getRecords: getChecklistSettings })
   

  return (
    selectedProject && theme ?
      <>
        <>
          <DataGrid
            key={updateDate}
            style={{ boxShadow: "0 0 0 0" }}
            padding="dense"
            columns={columns}
            title={title}
            options={{
              headerStyle: {
                backgroundColor: theme.palette.grey[50],
                color: theme.palette.text.primary,
              },
              onPageChange: (e) => setPage(e),
              initialPage: page,
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
            detailPanel={rowData => {
              return (
                <ChecklistDetails checklistItem={rowData}  callback={() => setUpdateDate(new Date)}></ChecklistDetails>
              )
            }}
          />
        </>
      </> : <SkeletonGrid title={title} />
  )
}